import { useEffect, useId } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import organizationProfileStore from '../../stores/organizationProfileStore'
import organizationSessionStore from '../../stores/organizationSessionStore'
import { activeAssignmentTargets, mayAssignResource } from '../../tenancy/resourceAssignmentPolicy'

export default function ResourceAssignmentControl({ assigneeMembershipId, onAssign, disabled = false, label = 'Ответственный' }) {
	const context = organizationSessionStore.currentContext
	const labelId = useId()
	const organizationId = context?.organization?.id
	const membershipRole = context?.membership?.role
	const membershipStatus = context?.membership?.status
	const canAssign = mayAssignResource(context)
	useEffect(() => {
		if (canAssign && !organizationProfileStore.profile && !organizationProfileStore.loading) organizationProfileStore.load()
	}, [organizationId, membershipRole, membershipStatus, canAssign])
	if (!canAssign) return null
	const targets = activeAssignmentTargets(organizationProfileStore.profile)
	return <FormControl size='small' fullWidth disabled={disabled} onClick={event => event.stopPropagation()}>
		<InputLabel id={labelId}>{label}</InputLabel>
		<Select
			labelId={labelId}
			label={label}
			value={assigneeMembershipId == null ? '' : String(assigneeMembershipId)}
			onChange={event => onAssign(event.target.value || null)}
		>
			<MenuItem value=''><em>Не назначен</em></MenuItem>
			{targets.map(target => <MenuItem key={target.id} value={target.id}>{target.label}</MenuItem>)}
		</Select>
	</FormControl>
}
